import React, { createContext, useContext, useState } from "react";

  // Add these imports at the top
import { useSelector } from "react-redux";
import { RootState } from "@/src/State/store";
import { getDefaultRoamingDayConfig } from "./utils/Roamingdaysutils";

interface CountryTraveller {
  country: string;
  count: string;
}

export interface RowData {
  buttonType: string;
  buttonText: string;
  buttonTypeDropdown: string;
  websiteUrl: string;
  countryCode: string;
  callPhoneNumber: string;
  copyOfferCode: string;
  quickReplyResponse?: string;  // ✅ Add this line
  optOut?: boolean;              // ✅ Add this line
}


interface Country {
  country_name: string;
  country_code: string;
  country_iso: string;
}

export interface CountryOption {
  label: string;
  value: string;
  disabled: boolean;
}

interface UpdateModeToCountryOption {
  label: string;
  value: string;
}


interface TravellerCountEntry {
  count: number;
  tocountry: string;
  fromcountry: string;
}

interface MediaConfig {
  file_name: string;
  file_type: string;
  binary_data: string;
  file_length: string;
}

interface ButtonValidationErrors {
  [buttonIndex: number]: {
    buttonText?: string;
    websiteUrl?: string;
    callPhoneNumber?: string;
    countryCode?: string;
    offerCode?: string;
    buttonType?: string;
    [key: string]: string | undefined; // Add this line
  };
}



interface TravellerCountEntry {
  count: number;
  tocountry: string;
  fromcountry: string;
}





interface CampaignContextType {

  


  roamingDaysByCountry: {
    [iso: string]: {
      condition_a: { con_operator: string; value: number };
      condition_b: { con_operator: string; value: number } | null;
    };
  };
  setRoamingDaysByCountry: React.Dispatch<
    React.SetStateAction<{
      [iso: string]: {
        condition_a: { con_operator: string; value: number };
        condition_b: { con_operator: string; value: number } | null;
      };
    }>
  >;


  isTestMode: boolean;
setIsTestMode: (value: boolean) => void;




  // Campaign Details
  campaignName: string;
  setCampaignName: React.Dispatch<React.SetStateAction<string>>;
  campaignDesc: string;
  setCampaignDesc: React.Dispatch<React.SetStateAction<string>>;

  // Country Selection
  fromCountries: string[];
  setFromCountries: React.Dispatch<React.SetStateAction<string[]>>;
  toCountry: string | null;
  setToCountry: React.Dispatch<React.SetStateAction<string | null>>;

  // Country Options
  FromCountryOptions: { label: string; value: string }[];
  setFromCountryOptions: React.Dispatch<React.SetStateAction<{ label: string; value: string }[]>>;
  ToCountryOptions: { label: string; value: string }[];
  setToCountryOptions: React.Dispatch<React.SetStateAction<{ label: string; value: string }[]>>;
  allToCountryOptions: { label: string; value: string }[];
  setAllToCountryOptions: React.Dispatch<React.SetStateAction<{ label: string; value: string }[]>>;

  // ISO Mapping
  fromCountryISOs: { [code: string]: string };
  setFromCountryISOs: React.Dispatch<React.SetStateAction<{ [code: string]: string }>>;
  toCountryISOs: { [code: string]: string };
  setToCountryISOs: React.Dispatch<React.SetStateAction<{ [code: string]: string }>>;

  // Selected ISO Codes
  // selectedFromCountryISOs: string[];
  // setSelectedFromCountryISOs: React.Dispatch<React.SetStateAction<string[]>>;
  selectedToCountryISO: string | null;
  setSelectedToCountryISO: React.Dispatch<React.SetStateAction<string | null>>;


  // ISO ➝ Code mapping for FromCountries
  fromCountryCodeMap: { [iso: string]: string };
  setFromCountryCodeMap: React.Dispatch<React.SetStateAction<{ [iso: string]: string }>>;

  // Stores country codes (e.g., "91", "256") that are reverse-mapped from selected ISO codes
  selectedFromCountryCodes: string[];
  setSelectedFromCountryCodes: React.Dispatch<React.SetStateAction<string[]>>;

  // Reverse mapping of To Countries (country_iso ➝ country_code)
  toCountryCodeMap: { [iso: string]: string };
  setToCountryCodeMap: React.Dispatch<React.SetStateAction<{ [iso: string]: string }>>;

  // Stores the selected To Country's country code (after reverse mapping from ISO)
  selectedToCountryCode: string | null;
  setSelectedToCountryCode: React.Dispatch<React.SetStateAction<string | null>>;






  // Schedule
  campaignStartDate: string;
  setCampaignStartDate: React.Dispatch<React.SetStateAction<string>>;
  campaignEndDate: string;
  setCampaignEndDate: React.Dispatch<React.SetStateAction<string>>;
  startTime: string;
  setStartTime: React.Dispatch<React.SetStateAction<string>>;
  endTime: string;
  setEndTime: React.Dispatch<React.SetStateAction<string>>;
  // To Country timezones
  timezoneOptions: { label: string; value: string }[];
  setTimezoneOptions: React.Dispatch<React.SetStateAction<{ label: string; value: string }[]>>;
  // Selected timezone
  selectedTimeZone: { value: string; label: string } | null;
  setSelectedTimeZone: React.Dispatch<React.SetStateAction<{ value: string; label: string } | null>>;


  // Advanced Settings
  // roamingDays: string | null;
  // setRoamingDays: React.Dispatch<React.SetStateAction<string | null>>;
  allocationType: string;
  setAllocationType: React.Dispatch<React.SetStateAction<string>>;
  isDuplicatePrevented: boolean;
  setIsDuplicatePrevented: React.Dispatch<React.SetStateAction<boolean>>;
  isPremiumOnly: boolean;
  setIsPremiumOnly: React.Dispatch<React.SetStateAction<boolean>>;
  audienceType: string;
  setAudienceType: (value: string) => void;
  selectedCampaign: string;
  setSelectedCampaign: (value: string) => void;

  // Channel Selection
  selectedChannels: string[];
  setSelectedChannels: React.Dispatch<React.SetStateAction<string[]>>;



  // Channel Content
  whatsappContent: any;
  setWhatsappContent: React.Dispatch<React.SetStateAction<any>>;
  smsContent: any;
  setSmsContent: React.Dispatch<React.SetStateAction<any>>;

  // Traveller Counts
  whatsappData: CountryTraveller[];
  setWhatsappData: React.Dispatch<React.SetStateAction<CountryTraveller[]>>;
  smsData: CountryTraveller[];
  setSmsData: React.Dispatch<React.SetStateAction<CountryTraveller[]>>;

  // Country-wise by Channel (UPDATED)
  whatsappCountries: { name: string; iso: string }[];
  setWhatsappCountries: React.Dispatch<React.SetStateAction<{ name: string; iso: string }[]>>;
  smsCountries: { name: string; iso: string }[];
  setSmsCountries: React.Dispatch<React.SetStateAction<{ name: string; iso: string }[]>>;

  // Channel Options
  channelOptions: { label: string; value: string }[];
  setChannelOptions: React.Dispatch<React.SetStateAction<{ label: string; value: string }[]>>;

  // Message Estimation
  estimatedMessageNeeded: number;
  setEstimatedMessageNeeded: React.Dispatch<React.SetStateAction<number>>;
  partsCount: number;
  setPartsCount: React.Dispatch<React.SetStateAction<number>>;

  //WhatsApp Conent
  // Language
  language: string;
  setLanguage: React.Dispatch<React.SetStateAction<string>>;

  // Header Type
  headerType: string;
  setHeaderType: React.Dispatch<React.SetStateAction<string>>;

  // Selected Header Option
  selectedOption: string;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;


  // HeaderText Input
  textInput: string;
  setTextInput: React.Dispatch<React.SetStateAction<string>>;

  //File Input
  selectedFile: File | null;
  setSelectedFile: React.Dispatch<React.SetStateAction<File | null>>;

  //File name
  fileName: string;
  setFileName: (name: string) => void;

  //File Length
  fileLength: string;
  setFileLength: (name: string) => void;

  //File Type
  fileType: string;
  setFileType: (name: string) => void;

  //base 64
  mediaBase64: string;
  setMediaBase64: (name: string) => void;



  //Image Preview
  previewImage: string | null;
  setPreviewImage: React.Dispatch<React.SetStateAction<string | null>>;


  // Message Body Text
  bodyText: string;
  setBodyText: React.Dispatch<React.SetStateAction<string>>;

  // Footer Text
  FooterText: string;
  setFooterText: React.Dispatch<React.SetStateAction<string>>;


  //Button Rows
  rows: RowData[];
  setRows: React.Dispatch<React.SetStateAction<RowData[]>>;


  //SMS Content
  //SMS Body
  body: string;
  setBody: React.Dispatch<React.SetStateAction<string>>;

  //Parts Count Warning
  showWarning: boolean;
  setShowWarning: React.Dispatch<React.SetStateAction<boolean>>;

  //Update Campaign
  updateCampaignId: number | null;
  setUpdateCampaignId: React.Dispatch<React.SetStateAction<number | null>>;

  //Update Mode
  isUpdateMode: boolean;
  setIsUpdateMode: React.Dispatch<React.SetStateAction<boolean>>;

  //View Mode
  isViewMode: boolean;
  setIsViewMode: React.Dispatch<React.SetStateAction<boolean>>;



  //Create Mode
  // isCreateMode: boolean;
  // setIsCreateMode: React.Dispatch<React.SetStateAction<boolean>>;

  //Overall COuntries including iso,code,country name for From Countries used for update
  countries: Country[];
  setCountries: React.Dispatch<React.SetStateAction<Country[]>>;


  //Overall COuntries including iso,code,country name for From Countries used for update
  targetCountries: Country[];
  setTargetCountries: React.Dispatch<React.SetStateAction<Country[]>>;




  //Readonly COuntries
  readonlyFromCountries: string[];
  setReadonlyFromCountries: React.Dispatch<React.SetStateAction<string[]>>;



  //FromCOuntry ISOs from API during Update
  fromCountryISOsFromAPI: string[];
  setFromCountryISOsFromAPI: React.Dispatch<React.SetStateAction<string[]>>;

  //Read only fromcountryoptions for Update Campaign
  readonlyFromCountryOptions: CountryOption[];
  setReadonlyFromCountryOptions: (options: CountryOption[]) => void;


  //TocoutryISOfromAPI
  toCountryISOFromAPI: string | null;
  setToCountryISOFromAPI: React.Dispatch<React.SetStateAction<string | null>>;

  //UpdateMode ToCOuntry Options
  updateModeToCountryOptions: UpdateModeToCountryOption[];
  setUpdateModeToCountryOptions: React.Dispatch<React.SetStateAction<UpdateModeToCountryOption[]>>;

  //Traveller Count for Update Campaign Mode
  updateModeTravellerCount: {
    sms_count: TravellerCountEntry[];
    whatsapp_count: TravellerCountEntry[];
  };
  setUpdateModeTravellerCount: React.Dispatch<
    React.SetStateAction<{
      sms_count: TravellerCountEntry[];
      whatsapp_count: TravellerCountEntry[];
    }>
  >;
  //Channel Options for Update
  updateModeChannelOptions: { label: string; value: string }[];
  setUpdateModeChannelOptions: React.Dispatch<React.SetStateAction<{ label: string; value: string }[]>>;


  //Minimum and Maximum Traveller Count
  minLimit: string;
  setMinLimit: React.Dispatch<React.SetStateAction<string>>;
  maxLimit: string;
  setMaxLimit: React.Dispatch<React.SetStateAction<string>>;
  countValidationAgainstEachCountry: {
    whatsapp: { [countryIndex: number]: string };
    sms: { [countryIndex: number]: string };
  };
  setCountValidationAgainstEachCountry: React.Dispatch<
    React.SetStateAction<{
      whatsapp: { [countryIndex: number]: string };
      sms: { [countryIndex: number]: string };
    }>
  >;

  //Has sufficient Messages 
  hasInsufficientMessages: boolean;
  setHasInsufficientMessages: (value: boolean) => void;

  //Media Config
  mediaConfig?: MediaConfig; // optional or can also be `MediaConfig | undefined`
  setMediaConfig: React.Dispatch<React.SetStateAction<MediaConfig | undefined>>;


  //CampaignName Validation
  campaignNames: string[];
  setCampaignNames: React.Dispatch<React.SetStateAction<string[]>>;



  //DraftName Validation
  draftNames: string[];
  setDraftNames: React.Dispatch<React.SetStateAction<string[]>>;

  //HeaderText


  //Loading
  isLoading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;



  // Draft Mode Traveller Count (similar to update mode)
  draftModeTravellerCount: {
    sms_count: TravellerCountEntry[];
    whatsapp_count: TravellerCountEntry[];
  };
  setDraftModeTravellerCount: React.Dispatch<
    React.SetStateAction<{
      sms_count: TravellerCountEntry[];
      whatsapp_count: TravellerCountEntry[];
    }>
  >;

  // Draft mode channel options (similar to update mode)
  draftModeChannelOptions: { label: string; value: string }[];
  setDraftModeChannelOptions: React.Dispatch<React.SetStateAction<{ label: string; value: string }[]>>;

  // Flag to indicate if we're in draft mode
  isDraftMode: boolean;
  setIsDraftMode: React.Dispatch<React.SetStateAction<boolean>>;


  //DraftId
  draftId: number | null;
  setDraftId: React.Dispatch<React.SetStateAction<number | null>>;


  //isDraftToBeSavedAutomatically
  isDraftToBeSavedAutomatically: boolean;
  setIsDraftToBeSavedAutomatically: React.Dispatch<React.SetStateAction<boolean>>;

  //IsDraftValidated
  lastValidationFailed: boolean;
  setLastValidationFailed: React.Dispatch<React.SetStateAction<boolean>>;

  isTravellerCountExceeded: boolean;
  setIsTravellerCountExceeded: (value: boolean) => void;















  //Error States

  //CampaignName Error
  campaignNameError: string | null;
  setCampaignNameError: React.Dispatch<React.SetStateAction<string | null>>;

  //CampaignName Error
  draftNameError: string | null;
  setDraftNameError: React.Dispatch<React.SetStateAction<string | null>>;

  //FromCountry Error
  fromCountryError: string | null;
  setFromCountryError: React.Dispatch<React.SetStateAction<string | null>>;

  //ToCoutry Error
  toCountryError: string | null;
  setToCountryError: React.Dispatch<React.SetStateAction<string | null>>;

  //Content Error
  contentError: string | null;
  setContentError: React.Dispatch<React.SetStateAction<string | null>>;

  //StartDate Error
  startDateError: string | null;
  setStartDateError: React.Dispatch<React.SetStateAction<string | null>>;


  //EndDate Error
  endDateError: string | null;
  setEndDateError: React.Dispatch<React.SetStateAction<string | null>>;

  //StartTime Error
  startTimeError: string | null;
  setStartTimeError: React.Dispatch<React.SetStateAction<string | null>>;

  //EndTime Error
  endTimeError: string | null;
  setEndTimeError: React.Dispatch<React.SetStateAction<string | null>>;


  //timeZone Error
  timeZoneError: string | null;
  setTimeZoneError: React.Dispatch<React.SetStateAction<string | null>>;




  //Whatsapp Content Error
  //Language Error
  languageError: string | null;
  setLanguageError: React.Dispatch<React.SetStateAction<string | null>>;

  //Header Text Error
  headerTextError: string | null;
  setHeaderTextError: React.Dispatch<React.SetStateAction<string | null>>;

  //Footer Text Error
  whatsappFooterError: string | null;
  setWhatsappFooterError: React.Dispatch<React.SetStateAction<string | null>>;



  // Upload Error
  uploadError: string | null;
  setUploadError: (error: string | null) => void;


  //WhatsApp Body Error
  whatsappBodyError: string | null;
  setWhatsappBodyError: React.Dispatch<React.SetStateAction<string | null>>;

  //WhatsApp Button Error
  // buttonTextError: string | null;
  // setButtonTextError: React.Dispatch<React.SetStateAction<string | null>>;

  //  websiteUrlError: string | null;
  //  setWebsiteUrlError: React.Dispatch<React.SetStateAction<string | null>>;

  //  callPhoneNumberError: string | null;
  //  setCallPhoneNumberError: React.Dispatch<React.SetStateAction<string | null>>;

  //  countryCodeError: string | null;
  //  setCountryCodeError: React.Dispatch<React.SetStateAction<string | null>>;

  //  offerCodeError: string | null;
  //  setOfferCodeError: React.Dispatch<React.SetStateAction<string | null>>;

  //  buttonTypeError: string | null;
  //  setButtonTypeError: React.Dispatch<React.SetStateAction<string | null>>;

  //  buttonsError: string | null;
  //  setButtonsError: React.Dispatch<React.SetStateAction<string | null>>;


  // With this new structure:
  buttonValidationErrors: ButtonValidationErrors;
  setButtonValidationErrors: React.Dispatch<React.SetStateAction<ButtonValidationErrors>>;
  buttonsError: string | null;
  setButtonsError: React.Dispatch<React.SetStateAction<string | null>>;

  // Helper functions for button validation
  setButtonError: (buttonIndex: number, field: string, error: string | null) => void;
  getButtonError: (buttonIndex: number, field: string) => string | undefined;
  clearButtonErrors: (buttonIndex?: number) => void;





  //PhoneNumber Error
  phoneNumberError: string | null;
  setPhoneNumberError: React.Dispatch<React.SetStateAction<string | null>>;

  //SMS Content Error
  //SMS Body Error
  smsBodyError: string | null;
  setSmsBodyError: React.Dispatch<React.SetStateAction<string | null>>;


  //isSumbitButton Attempted
  isSubmitAttempted: boolean;
  setIsSubmitAttempted: (value: boolean) => void;




  //isDraftSumbitButton Attempted
  isDraftSubmitAttempted: boolean;
  setIsDraftSubmitAttempted: (value: boolean) => void;

  //WhatsApp COntent Submit Attempted
  isWhatsappContentSubmitAttempted: boolean;
  setIsWhatsappContentSubmitAttempted: React.Dispatch<React.SetStateAction<boolean>>;

  //SMS Content Submit Attempted
  isSmsContentSubmitAttempted: boolean;
  setIsSmsContentSubmitAttempted: React.Dispatch<React.SetStateAction<boolean>>;




  // Reset Function
  resetCampaign: () => void;
  resetWhatsappContent: () => void;
  resetSMSContent: () => void;
}

const CampaignContext = createContext<CampaignContextType | undefined>(undefined);

export const CampaignProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {


  // ✅ NEW: Roaming days by country (ISO-based)
  const [roamingDaysByCountry, setRoamingDaysByCountry] = useState<{
    [iso: string]: {
      condition_a: { con_operator: string; value: number };
      condition_b: { con_operator: string; value: number } | null;
    };
  }>({});


  

// Inside CampaignProvider component, after all state declarations:
const selectedFromCountryISOs = useSelector(
  (state: RootState) => state.advertiserAccount.selectedFromCountryISOs
);

const [isTestMode, setIsTestMode] = useState(false);


  // Campaign Details
  const [campaignName, setCampaignName] = useState("");
  const [campaignDesc, setCampaignDesc] = useState("");

  // Country Selection
  const [fromCountries, setFromCountries] = useState<string[]>([]);
  const [toCountry, setToCountry] = useState<string | null>(null);

  // Country Options
  const [FromCountryOptions, setFromCountryOptions] = useState<{ label: string; value: string }[]>([]);
  const [ToCountryOptions, setToCountryOptions] = useState<{ label: string; value: string }[]>([]);
  const [allToCountryOptions, setAllToCountryOptions] = useState<{ label: string; value: string }[]>([]);

  // ISO Mapping
  const [fromCountryISOs, setFromCountryISOs] = useState<{ [code: string]: string }>({});
  const [toCountryISOs, setToCountryISOs] = useState<{ [code: string]: string }>({});
  // const [selectedFromCountryISOs, setSelectedFromCountryISOs] = useState<string[]>([]);
  const [selectedToCountryISO, setSelectedToCountryISO] = useState<string | null>(null);


  // Holds a mapping of country ISO → country code (used for reverse lookup when preparing payloads)
  const [fromCountryCodeMap, setFromCountryCodeMap] = useState<{ [iso: string]: string }>({});

  // Reverse-mapped selected From Country Codes from ISO (e.g., { 'ug': '256' })
  const [selectedFromCountryCodes, setSelectedFromCountryCodes] = useState<string[]>([]);

  // 🔁 Reverse mapping of To Countries: { country_iso ➝ country_code }
  // Used for converting selected ISO back to country code (e.g., for payload)
  const [toCountryCodeMap, setToCountryCodeMap] = useState<{ [iso: string]: string }>({});


  // Stores the country code (e.g., "91") of the selected To Country,
  // derived by reverse mapping from the selected country ISO (e.g., "in")
  const [selectedToCountryCode, setSelectedToCountryCode] = useState<string | null>(null);




  // Schedule
  const [campaignStartDate, setCampaignStartDate] = useState("");
  const [campaignEndDate, setCampaignEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  // Timezone data based on selected To Country
  const [timezoneOptions, setTimezoneOptions] = useState<{ label: string; value: string }[]>([]);
  // Selected timezone string, e.g., "Asia/Kolkata"
  const [selectedTimeZone, setSelectedTimeZone] = useState<{ value: string; label: string } | null>(null);



  // Advanced Settings
  // const [roamingDays, setRoamingDays] = useState<string | null>("1");
  const [allocationType, setAllocationType] = useState("Lifetime Allocation");
  const [isDuplicatePrevented, setIsDuplicatePrevented] = useState(true);
  const [isPremiumOnly, setIsPremiumOnly] = useState(false);
  const [audienceType, setAudienceType] = useState<string>("None");
  const [selectedCampaign, setSelectedCampaign] = useState<string>("");

  // Channel Selection
  const [selectedChannels, setSelectedChannels] = useState<string[]>([]);

  // Channel Content
  const [whatsappContent, setWhatsappContent] = useState<any>(null);
  const [smsContent, setSmsContent] = useState<any>(null);

  // Traveller Counts
  const [whatsappData, setWhatsappData] = useState<CountryTraveller[]>([]);
  const [smsData, setSmsData] = useState<CountryTraveller[]>([]);

  // Country-wise by Channel (UPDATED)
  const [whatsappCountries, setWhatsappCountries] = useState<{ name: string; iso: string }[]>([]);
  const [smsCountries, setSmsCountries] = useState<{ name: string; iso: string }[]>([]);

  // Channel Options
  const [channelOptions, setChannelOptions] = useState<{ label: string; value: string }[]>([]);

  // Estimation
  const [estimatedMessageNeeded, setEstimatedMessageNeeded] = useState(0);
  const [partsCount, setPartsCount] = useState(1);

  //WhatsApp Content
  //language
  const [language, setLanguage] = useState("");

  // Upload Error
  const [uploadError, setUploadError] = useState<string | null>(null);


  //headertype
  const [headerType, setHeaderType] = useState<string>("");

  //Selected Header Option
  const [selectedOption, setSelectedOption] = useState<string>("");

  //headerText 
  const [textInput, setTextInput] = useState<string>("");

  //FileInput
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  //File name
  const [fileName, setFileName] = useState("");

  //File length
  const [fileLength, setFileLength] = useState("");

  //File Type
  const [fileType, setFileType] = useState("");

  // base64
  const [mediaBase64, setMediaBase64] = useState("");

  //Image Preview
  const [previewImage, setPreviewImage] = useState<string | null>(null);

  //Whatsapp body
  const [bodyText, setBodyText] = useState<string>("");


  //footer
  const [FooterText, setFooterText] = useState<string>("");

  // Button Rows
  const [rows, setRows] = useState<RowData[]>([]);

  //SMS Content
  //SMS Body
  const [body, setBody] = useState<string>("");

  //Parts Count Warning 
  const [showWarning, setShowWarning] = useState<boolean>(false);


  //Below are the states used specifically for Update Campaign
  const [updateCampaignId, setUpdateCampaignId] = useState<number | null>(null);

  //Update Mode State
  const [isUpdateMode, setIsUpdateMode] = useState<boolean>(false);


  //View Mode State
  const [isViewMode, setIsViewMode] = useState<boolean>(false);




  //Overall COuntries including iso,code,country name which is used for FromCountries
  const [countries, setCountries] = useState<Country[]>([]);

  const [targetCountries, setTargetCountries] = useState<Country[]>([]);

  //Read only countries showing in FromCOuntries during Update Campaign
  const [readonlyFromCountries, setReadonlyFromCountries] = useState<string[]>([]);

  //FromCoutryISOsFromAPI are stored here during Update Campaign
  const [fromCountryISOsFromAPI, setFromCountryISOsFromAPI] = useState<string[]>([]);

  //TocoutryISOfromAPI stored here during Update Campaign
  const [toCountryISOFromAPI, setToCountryISOFromAPI] = useState<string | null>(null);

  //Readonly options for update campaign
  const [readonlyFromCountryOptions, setReadonlyFromCountryOptions] = useState<
    { label: string; value: string; disabled: boolean }[]
  >([]);

  //ToCOuntry Options used  for Dropdown(Update mode) is stored here
  const [updateModeToCountryOptions, setUpdateModeToCountryOptions] = useState<
    { label: string; value: string }[]
  >([]);

  //Traveller Count used for Update Campaign  
  const [updateModeTravellerCount, setUpdateModeTravellerCount] = useState<{
    sms_count: { count: number; tocountry: string; fromcountry: string }[];
    whatsapp_count: { count: number; tocountry: string; fromcountry: string }[];
  }>({
    sms_count: [],
    whatsapp_count: [],
  });

  //Channel Options for Update Mode
  const [updateModeChannelOptions, setUpdateModeChannelOptions] = useState<
    { label: string; value: string }[]
  >([]);


  //Minimum and Maximum Count Validation
  const [minLimit, setMinLimit] = useState<string>("");
  const [maxLimit, setMaxLimit] = useState<string>("");
  const [countValidationAgainstEachCountry, setCountValidationAgainstEachCountry] = useState<{
    whatsapp: { [countryIndex: number]: string };
    sms: { [countryIndex: number]: string };
  }>({
    whatsapp: {},
    sms: {}
  });

  //Has Sufficiet Messages State
  const [hasInsufficientMessages, setHasInsufficientMessages] = useState(false);

  //Media Config for WhatsApp Content
  const [mediaConfig, setMediaConfig] = useState<MediaConfig | undefined>();


  //Campaign Name Validation
  const [campaignNames, setCampaignNames] = useState<string[]>([]);

  const [draftNames, setDraftNames] = useState<string[]>([]);

  //Loading
  const [isLoading, setLoading] = useState(false);



  // Draft Mode states
  const [draftModeTravellerCount, setDraftModeTravellerCount] = useState<{
    sms_count: TravellerCountEntry[];
    whatsapp_count: TravellerCountEntry[];
  }>({
    sms_count: [],
    whatsapp_count: []
  });

  const [draftModeChannelOptions, setDraftModeChannelOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const [isDraftMode, setIsDraftMode] = useState(false);

  const [draftId, setDraftId] = useState<number | null>(null);

  const [isDraftToBeSavedAutomatically, setIsDraftToBeSavedAutomatically] = useState<boolean>(false);

  const [lastValidationFailed, setLastValidationFailed] = useState<boolean>(false);

  const [isTravellerCountExceeded, setIsTravellerCountExceeded] = useState(false);














  // // In your UseCampaignContext provider component
  // console.log("🔄 Context Provider Rendering - isCreateMode:", isCreateMode);










  //Error States

  //isSubmitButton Clicked
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);


  //isDraftSubmitButton Clicked
  const [isDraftSubmitAttempted, setIsDraftSubmitAttempted] = useState(false);



  //WhatsApp Content Submit Button Attempted
  const [isWhatsappContentSubmitAttempted, setIsWhatsappContentSubmitAttempted] = useState(false);

  //SMS Content Submit Attempted
  const [isSmsContentSubmitAttempted, setIsSmsContentSubmitAttempted] = useState<boolean>(false);






  // CampaignName Error
  const [campaignNameError, setCampaignNameError] = useState<string | null>(null);


  // DraftName Error
  const [draftNameError, setDraftNameError] = useState<string | null>(null);

  // FromCountry Error
  const [fromCountryError, setFromCountryError] = useState<string | null>(
    null
  );

  // ToCountry Error  
  const [toCountryError, setToCountryError] = useState<string | null>(
    null
  );

  // Content Error 
  const [contentError, setContentError] = useState<string | null>(
    null
  );

  //StartDate Error
  const [startDateError, setStartDateError] = useState<string | null>(null);

  //EndDate Error
  const [endDateError, setEndDateError] = useState<string | null>(null);

  //StartTime Error
  const [startTimeError, setStartTimeError] = useState<string | null>(null);

  //EndTime Error
  const [endTimeError, setEndTimeError] = useState<string | null>(null);

  const [timeZoneError, setTimeZoneError] = useState<string | null>(null);


  //WhatsApp Content Error
  const [languageError, setLanguageError] = useState<string | null>(null);

  //WhatsApp Header Text Error
  const [headerTextError, setHeaderTextError] = useState<string | null>(null);

  //WhatsApp Body Error
  const [whatsappBodyError, setWhatsappBodyError] = useState<string | null>(null);

  //WhatsApp Footer Error
  const [whatsappFooterError, setWhatsappFooterError] = useState<string | null>(null);

  //WhatSApp Button Error
  // const [buttonTextError, setButtonTextError] = useState<string | null>(null);
  // const [websiteUrlError, setWebsiteUrlError] = useState<string | null>(null);
  // const [callPhoneNumberError, setCallPhoneNumberError] = useState<string | null>(null);
  // const [countryCodeError, setCountryCodeError] = useState<string | null>(null);
  // const [offerCodeError, setOfferCodeError] = useState<string | null>(null);
  // const [buttonTypeError, setButtonTypeError] = useState<string | null>(null);
  // const [buttonsError, setButtonsError] = useState<string | null>(null);



  // Replace individual button error states with:
  const [buttonValidationErrors, setButtonValidationErrors] = useState<ButtonValidationErrors>({});
  const [buttonsError, setButtonsError] = useState<string | null>(null);

  // Helper functions for button validation (unchanged)
  // const setButtonError = (buttonIndex: number, field: string, error: string | null) => {
  //   setButtonValidationErrors(prev => ({
  //     ...prev,
  //     [buttonIndex]: {
  //       ...prev[buttonIndex],
  //       ...(error ? { [field]: error } : (() => {
  //         const { [field]: removed, ...rest } = prev[buttonIndex] || {};
  //         return rest;
  //       })())
  //     }
  //   }));
  // };


  const setButtonError = (buttonIndex: number, field: string, error: string | null) => {
    setButtonValidationErrors(prev => {
      const newState = { ...prev };

      if (!newState[buttonIndex]) {
        newState[buttonIndex] = {};
      }

      if (error) {
        newState[buttonIndex][field] = error;
      } else {
        delete newState[buttonIndex][field];

        // Clean up empty button error objects
        if (Object.keys(newState[buttonIndex]).length === 0) {
          delete newState[buttonIndex];
        }
      }

      return newState;
    });
  };

  const getButtonError = (buttonIndex: number, field: string): string | undefined => {
    return buttonValidationErrors[buttonIndex]?.[field as keyof ButtonValidationErrors[number]];
  };

  const clearButtonErrors = (buttonIndex?: number) => {
    if (buttonIndex !== undefined) {
      setButtonValidationErrors(prev => {
        const { [buttonIndex]: removed, ...rest } = prev;
        return rest;
      });
    } else {
      setButtonValidationErrors({});
    }
  };




  const [phoneNumberError, setPhoneNumberError] = useState<string | null>(null);

  //SMS Content
  //SMS Body Error
  const [smsBodyError, setSmsBodyError] = useState<string | null>(null);



// Add this useEffect
React.useEffect(() => {


     if (isUpdateMode || isViewMode) return;


  if (!selectedFromCountryISOs || selectedFromCountryISOs.length === 0) {
    setRoamingDaysByCountry({});
    return;
  }

  setRoamingDaysByCountry((prev) => {
    const updated = { ...prev };
    const currentISOs = selectedFromCountryISOs.map((iso: string) => iso.toUpperCase());
    const existingISOs = Object.keys(prev);

    // Add defaults for new countries
    currentISOs.forEach((iso: string) => {
      if (!existingISOs.includes(iso)) {
        updated[iso] = getDefaultRoamingDayConfig();
      }
    });

    // Remove countries that are no longer selected
    existingISOs.forEach((iso) => {
      if (!currentISOs.includes(iso)) {
        delete updated[iso];
      }
    });

    return updated;
  });
}, [selectedFromCountryISOs, isUpdateMode, isViewMode]);





  // Reset
  const resetCampaign = () => {
    setCampaignName("");
    setCampaignDesc("");
    setFromCountries([]);
    setToCountry(null);
    setFromCountryOptions([]);
    setUpdateModeChannelOptions([]);
    setDraftModeChannelOptions([]);
    setChannelOptions([]);
    setDraftModeTravellerCount({
      sms_count: [],
      whatsapp_count: []
    });
    setToCountryOptions([]);
    setAllToCountryOptions([]);
    setFromCountryISOs({});
    setToCountryISOs({});
    // setSelectedFromCountryISOs([]);
    setSelectedToCountryISO(null);
    setCampaignStartDate("");
    setCampaignEndDate("");
    setStartTime("");
    setEndTime("");
    // setRoamingDays("1");
    setAllocationType("Lifetime Allocation");
    setIsDuplicatePrevented(true);
    setIsPremiumOnly(false);
    setSelectedChannels([]);
    setWhatsappContent(null);
    setSmsContent(null);
    setWhatsappData([]);
    setSmsData([]);
    setWhatsappCountries([]);
    setSmsCountries([]);
    setChannelOptions([]);
    setEstimatedMessageNeeded(0);
    setPartsCount(1);
    setCampaignNameError(null);
    setDraftNameError(null);
    setFromCountryError(null);
    setToCountryError(null);
    setContentError(null);
    setStartDateError(null);
    setEndDateError(null);
    setStartTimeError(null);
    setEndTimeError(null);
    setIsSubmitAttempted(false);
    setIsDraftSubmitAttempted(false);
    setDraftId(null);
    setFileName("");
    setFileType("");
    setMediaBase64("");
    setSelectedOption("");
    setRoamingDaysByCountry({});
    setAudienceType("None");  // Reset to default "None"
setSelectedCampaign("");  
setIsTravellerCountExceeded(false);
    setCountValidationAgainstEachCountry({
      whatsapp: [],
      sms: [],
    });

    setMediaConfig({
      file_name: "",
      file_type: "",
      binary_data: "",
      file_length: "",
    });
  };





  // Reset WhatsApp Content
  const resetWhatsappContent = () => {
    setLanguage("");
    setHeaderType("");
    setTextInput("");
    setSelectedFile(null);
    setPreviewImage(null);
    setBodyText("");
    setFooterText("");
    setRows([]);
    setLanguageError(null);
    setWhatsappBodyError(null);
    setPhoneNumberError(null);
    setIsWhatsappContentSubmitAttempted(false);
    setUploadError(null);
    setWhatsappContent(null);
    setButtonValidationErrors({});
    setButtonsError(null);


  };

  // Reset SMS Content
  const resetSMSContent = () => {
    setBody("");
    setSmsBodyError(null);
    setPartsCount(1);
    setShowWarning(false);
    setIsSmsContentSubmitAttempted(false);
    setSmsContent(null);
  };

  return (
    <CampaignContext.Provider
      value={{
        campaignName,
        setCampaignName,
        campaignDesc,
        setCampaignDesc,
        fromCountries,
        setFromCountries,
        toCountry,
        setToCountry,
        FromCountryOptions,
        setFromCountryOptions,
        ToCountryOptions,
        setToCountryOptions,
        allToCountryOptions,
        setAllToCountryOptions,
        fromCountryISOs,
        setFromCountryISOs,
        toCountryISOs,
        setToCountryISOs,
        // selectedFromCountryISOs,
        // setSelectedFromCountryISOs,
        selectedToCountryISO,
        setSelectedToCountryISO,
        campaignStartDate,
        setCampaignStartDate,
        campaignEndDate,
        setCampaignEndDate,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        // roamingDays,
        // setRoamingDays,
        allocationType,
        setAllocationType,
        isDuplicatePrevented,
        setIsDuplicatePrevented,
        isPremiumOnly,
        setIsPremiumOnly,
        selectedChannels,
        setSelectedChannels,
        whatsappContent,
        setWhatsappContent,
        smsContent,
        setSmsContent,
        whatsappData,
        setWhatsappData,
        smsData,
        setSmsData,
        whatsappCountries,
        setWhatsappCountries,
        smsCountries,
        setSmsCountries,
        channelOptions,
        setChannelOptions,
        estimatedMessageNeeded,
        setEstimatedMessageNeeded,
        partsCount,
        setPartsCount,
        campaignNameError,
        setCampaignNameError,
        resetCampaign,
        fromCountryError,
        setFromCountryError,
        setToCountryError,
        toCountryError,
        setContentError,
        contentError,
        setStartDateError,
        startDateError,
        endDateError,
        setEndDateError,
        startTimeError,
        endTimeError,
        setEndTimeError,
        setStartTimeError,
        setIsSubmitAttempted,
        isSubmitAttempted,
        setLanguage,
        language,
        setBodyText,
        bodyText,
        setFooterText,
        FooterText,
        headerType,
        setHeaderType,
        textInput,
        setTextInput,
        setSelectedFile,
        selectedFile,
        setPreviewImage,
        previewImage,
        rows,
        setRows,
        languageError,
        setLanguageError,
        setIsWhatsappContentSubmitAttempted,
        isWhatsappContentSubmitAttempted,
        phoneNumberError,
        setPhoneNumberError,
        setWhatsappBodyError,
        whatsappBodyError,
        setBody,
        body,
        setShowWarning,
        showWarning,
        setSmsBodyError,
        smsBodyError,
        isSmsContentSubmitAttempted,
        setIsSmsContentSubmitAttempted,
        resetWhatsappContent,
        resetSMSContent,
        fromCountryCodeMap,
        setFromCountryCodeMap,
        setSelectedFromCountryCodes,
        selectedFromCountryCodes,
        setToCountryCodeMap,
        toCountryCodeMap,
        selectedToCountryCode,
        setSelectedToCountryCode,
        timezoneOptions,
        setTimezoneOptions,
        selectedTimeZone,
        setSelectedTimeZone,
        setTimeZoneError,
        timeZoneError,
        uploadError,
        setUploadError,
        setFileName,
        fileName,
        setFileLength,
        fileLength,
        setFileType,
        fileType,
        setMediaBase64,
        mediaBase64,
        setSelectedOption,
        selectedOption,
        setUpdateCampaignId,
        updateCampaignId,
        countries,
        setCountries,
        setReadonlyFromCountries,
        readonlyFromCountries,
        setFromCountryISOsFromAPI,
        fromCountryISOsFromAPI,
        setReadonlyFromCountryOptions,
        readonlyFromCountryOptions,
        setToCountryISOFromAPI,
        toCountryISOFromAPI,
        setTargetCountries,
        targetCountries,
        updateModeToCountryOptions,
        setUpdateModeToCountryOptions,
        setUpdateModeTravellerCount,
        updateModeTravellerCount,
        setUpdateModeChannelOptions,
        updateModeChannelOptions,
        isUpdateMode,
        setIsUpdateMode,
        minLimit,
        setMinLimit,
        maxLimit,
        setMaxLimit,
        countValidationAgainstEachCountry,
        setCountValidationAgainstEachCountry,
        setHasInsufficientMessages,
        hasInsufficientMessages,
        setMediaConfig,
        mediaConfig,
        setCampaignNames,
        campaignNames,
        setHeaderTextError,
        headerTextError,
        setWhatsappFooterError,
        whatsappFooterError,
        buttonValidationErrors,
        setButtonValidationErrors,
        buttonsError,
        setButtonsError,
        setButtonError,
        getButtonError,
        clearButtonErrors,
        setLoading,
        isLoading,
        draftModeTravellerCount,
        setDraftModeTravellerCount,
        draftModeChannelOptions,
        setDraftModeChannelOptions,
        isDraftMode,
        setIsDraftMode,
        setIsViewMode,
        isViewMode,
        draftNames,
        setDraftNames,
        draftNameError,
        setDraftNameError,
        isDraftSubmitAttempted,
        setIsDraftSubmitAttempted,
        draftId,
        setDraftId,
        isDraftToBeSavedAutomatically,
        setIsDraftToBeSavedAutomatically,
        lastValidationFailed,
        setLastValidationFailed,
        roamingDaysByCountry,
        setRoamingDaysByCountry,
        audienceType,
        setAudienceType,
        selectedCampaign,
        setSelectedCampaign,
        isTestMode,
setIsTestMode,
isTravellerCountExceeded,
setIsTravellerCountExceeded,
        // isCreateMode,
        // setIsCreateMode
        // buttonTextError,
        // setButtonTextError,
        // websiteUrlError,
        // setWebsiteUrlError,
        // callPhoneNumberError,
        // setCallPhoneNumberError,
        // countryCodeError,
        // setCountryCodeError,
        // offerCodeError,
        // setOfferCodeError,
        // buttonTypeError,
        // setButtonTypeError,
        // buttonsError,
        // setButtonsError,


      }}
    >
      {children}
    </CampaignContext.Provider>
  );
};

export const useCampaignContext = () => {
  const context = useContext(CampaignContext);
  if (!context) {
    throw new Error("useCampaignContext must be used within a CampaignProvider");
  }
  return context;
};
